<template>
  <div class="form-element">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <textarea
      :placeholder="placeholder"
      class="form-element__textarea"
      @keyup="changed"
      v-model.trim="val"
    ></textarea>
    <div class="form-element__message" v-if="message">{{ message }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      val: this.value,
    };
  },
  watch: {
    value: function (val) {
      this.val = val;
    },
  },
  methods: {
    changed: function (e) {
      this.$emit("input", e.target.value);

      return e.target.value;
    },
  },
};
</script>